import React, { useState } from "react"
import Lightbox from 'react-image-lightbox'
import Img from "gatsby-image"
import usePhotogallery from "../utility/usePhotogallery"
import { FormattedMessage } from "react-intl"


const PhotoGallery = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [photoIndex, setPhotoIndex] = useState(0);
  const images = usePhotogallery();
  const length = images.length;

  const showImage = (i) => {
    setPhotoIndex(i);
    setIsOpen(true);
  }

  return (
    <section id="photogallery" className="section text-center photogallery clearfix" aria-labelledby="region-photogallery">
      <div className="container">
        <div className="row">
          <div className="col-sm-12 col-md-8 col-md-offset-2">
            <h1 id="region-photogallery" className="section__title" data-aos="fade-up">
              <FormattedMessage id="fotogallery-titolo" />
            </h1>
            <div className="row" data-aos="fade-up">
              {images.map((item, i) => (
                <React.Fragment key={i}>
                  <div className="col-xs-6 col-sm-4">
                    <div className="photogallery__box">
                      <div className="photogallery__wrapper">
                        <div className="photogallery__link" onClick={() => showImage(i)} >
                          <Img fluid={item.thumb} alt="" className="photogallery__img" />
                        </div>
                      </div>
                    </div>
                  </div>
                  {(i + 1) % 2 === 0 && <div className="clearfix visible-xs-block"></div>}
                  {(i + 1) % 3 === 0 && <div className="clearfix visible-sm-block visible-md-block visible-lg-block"></div>}
                </React.Fragment>
              ))}
            </div>
          </div>
        </div>
      </div>
      {isOpen && (
        <Lightbox
          mainSrc={images[photoIndex].imageUrl}
          nextSrc={images[(photoIndex + 1) % length].imageUrl}
          prevSrc={images[(photoIndex + length - 1) % length].imageUrl}
          onCloseRequest={() => setIsOpen(false)}
          onMovePrevRequest={() => setPhotoIndex(photoIndex => (photoIndex + length - 1) % length)}
          onMoveNextRequest={() => setPhotoIndex(photoIndex => (photoIndex + 1) % length)}
        />
      )}
    </section>
  );
}

export default PhotoGallery;